
import { mapState } from "vuex";
import ProfilePicturePreviewAndUpdate from "../common/profile-picture-preview-and-update.vue";
import UserSettingsProfilePicture from "../settings/user-settings-profile-picture.vue";
import CountrycodeWithTextfield from "../common/countrycode-with-textfield.vue";

export default {
  props: {
    restaurantDetails: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    UserSettingsProfilePicture,
    ProfilePicturePreviewAndUpdate,
    CountrycodeWithTextfield
  },
  data() {
    return {
      valid: false,
      isPhoneValid: false,
      userDetails: {
        display_name: "",
        isWhatsappEnabled: "no",
        website: "",
        isRequestedForWebsite: false,
        email: "",
        whatsapp_business_number: {
          country_code: "+91",
          number: ""
        },
        website: "",
        email: "",
        business_description: "",
        address: "",
        restaurant_logo: "",
        imgObj: {},
        isRequestedForWebsite: false
      },
      checkboxRule: [(v) => !!v],
      urlRule: [
        (v) =>
          (!!v && v.trim() !== "" && this.isURL(v)) ||
          "Valid channel URL is required"
      ],
      whatsappEnabledRule: [
        (v) => v !== "yes" || "WhatsApp cannot be enabled for this button"
      ]
    };
  },
  computed: {
    ...mapState("auth", ["user"]),
    isFormValid() {
      return this.valid && this.isPhoneValid;
    }
  },
  beforeMount() {
    if (Object.keys(this.restaurantDetails).length) {
      this.userDetails = { ...this.restaurantDetails };
    }
  },
  methods: {
    pictureChange(image) {
      this.userDetails.imgObj = image;
    },
    handleSubmit() {
      if (this.valid) {
        const { country_code, number } =
          this.userDetails.whatsapp_business_number;
        const payload = {
          ...this.userDetails,
          whatsapp_business_number: {
            country_code,
            number
          }
        };
        delete payload.country_code;
        if (this.userDetails.isRequestedForWebsite) {
          payload.website = "Requested for website";
        }
        this.$emit("restaurant-details-entered", payload);
      }
    }
  }
};
